export default __webpack_public_path__ + "static/media/filipa.bf65be25.png";